import { dispatchIdentify } from "./dispatch";
import { config } from "./load";
import { UserTraitsService } from "./traits";
import { IdentifyOptions } from "./types";
/**
 * Identify the user with Segment and Datadog RUM.
 * @param opts
 */
export async function identify(opts: IdentifyOptions): Promise<void> {
  if (!config || !config.apiHost) {
    throw new Error(
      `Cannot identify without an apiBaseUrl. You'll need to load the analytics config.`
    );
  }
  try {
    const { traits, email = "" } = opts;

    if (!config.makoAuthToken) {
      // If no auth token was passed, perform an anonymous identify.
      // Segment will generate an anonymousId to track the session.
      // Same with Datadog RUM.
      dispatchIdentify(undefined, traits, email);
      return;
    }

    // If an auth token is passed, fetch traits that we'd like
    // to consistently send for authenticated users, along with
    // any other traits passed by the client.
    const service = new UserTraitsService(config.apiHost, config.makoAuthToken!);
    const baseTraits = await service.fetch();
    const { userId } = baseTraits;

    // We have to know who the user is for authed identify to behave
    // as expected.
    if (!userId) {
      // If no userId is available, we can't identify the user, perform an anonymous identify
      dispatchIdentify(undefined, traits, email);
      return;
    }

    const allTraits: Record<string, any> = {
      ...baseTraits,
      ...traits,
    };

    // Don't send any null or undefined traits to segment
    Object.keys(allTraits).forEach((key) => {
      const value = allTraits[key];
      if (value === null || value === undefined) {
        delete allTraits[key];
      }
    });

    dispatchIdentify(userId.toString(), allTraits, email);
  } catch (error) {
    console.error("Failed to identify user", error);
  }
}
